/**
 * Apple Sign-In OAuth URL builder for web.
 *
 * Apple uses response_mode=form_post — Apple POSTs the result
 * to our callback URL instead of redirecting with query params.
 *
 * No client-side CSRF state: Apple form_post is cross-site, so SameSite=Lax
 * cookies are dropped, and SameSite=None breaks under Safari/iOS ITP and
 * private browsing. Real protection comes from the bearer id_token, which
 * the backend verifies against Apple's public keys (issuer, audience,
 * expiration, signature) — an attacker cannot forge or replay it.
 */
export function getAppleOAuthUrl(): string {
  const clientId = process.env.NEXT_PUBLIC_APPLE_CLIENT_ID;
  if (!clientId) {
    throw new Error('NEXT_PUBLIC_APPLE_CLIENT_ID is not configured');
  }

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: `${window.location.origin}/api/auth/apple/callback`,
    response_type: 'code id_token',
    response_mode: 'form_post',
    scope: 'name email',
  });

  return `https://appleid.apple.com/auth/authorize?${params.toString()}`;
}
